import { Button, Form, Col, Offcanvas, Card, Row } from "react-bootstrap";
import { Controller, set, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import Select from 'react-select';
import { Link, useNavigate } from "react-router-dom";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import { Label } from "../../components/Label/Label";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
}

interface formInterface {
    id: string;
    uuid: string;
    role: string;
    permissions: string | any[];
}

const modulePermissions = [
    { id: 1, name: "DASHBOARD", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 2, name: "PROJECTS", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 3, name: "BOOKINGS", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 4, name: "RECEIPTS", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 5, name: "EXPENSES", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 6, name: "USERS", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 7, name: "CUSTOMERS", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 8, name: "AGENTS", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 9, name: "PAYMENT_DUE_REPORT", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 10, name: "EXPENSES_REPORT", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 11, name: "SUMMARY_REPORT", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 12, name: "SUPPLIERS", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 13, name: "INVENTORY", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 14, name: "STOCK", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 15, name: "LOAN", can_read: true, can_write: false, can_delete: false, can_update: false },
    { id: 16, name: "DAY_BOOK", can_read: true, can_write: false, can_delete: false, can_update: false },
];


const AddRole = (props: PropData) => {
    const navigate = useNavigate();
    const { handleSubmit, formState: { errors }, control, watch, getValues, register, reset, setValue } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [permissions, setPermissions] = useState<any[]>([]);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                try {
                    setPermissions(props.data.permissions);
                } catch {
                    setPermissions([...modulePermissions]);
                }
                setIsEdit(true);
            } else {
                reset({});
                setPermissions([...modulePermissions]);
                resetForm();
                setIsEdit(false);
            }
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        data.permissions = permissions.map((perm) => ({
            id: perm.id,
            name: perm.name,
            can_read: perm.can_read,
            can_write: perm.can_write,
            can_delete: perm.can_delete,
            can_update: perm.can_update,
            full_access: (perm.can_read && perm.can_write && perm.can_update && perm.can_delete) ? true : false
        }));
        const url = isEdit ? `update-role` : "create-role";
        WebService[isEdit ? "putAPI" : 'postAPI']({ action: url, body: data, id: "changePassword-btn" })
            .then((res: any) => {
                toast.success(res.message);
                closeModal(true);
            }).catch((e) => { toast.error(e?.error); });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        setPermissions([...modulePermissions]);
        setValue('role', '');

    };

    const onChangePermission = (index: number, type: string) => {
        const updatedPermissions = [...permissions];
        if (type === "full_access") {
            const newFullAccess = !updatedPermissions[index].full_access;
            updatedPermissions[index] = {
                ...updatedPermissions[index],
                full_access: newFullAccess,
                can_read: newFullAccess,
                can_write: newFullAccess,
                can_update: newFullAccess,
                can_delete: newFullAccess,
            };
        } else if (type === "can_read") {
            // If disabling read, also disable update and delete
            const newcan_read = !updatedPermissions[index].can_read;
            updatedPermissions[index] = {
                ...updatedPermissions[index],
                can_read: newcan_read,
                can_update: newcan_read ? updatedPermissions[index].can_update : false,
                can_delete: newcan_read ? updatedPermissions[index].can_delete : false,
                can_write: newcan_read ? updatedPermissions[index].can_write : false,
            };
        } else {
            // Only allow update/delete if read is enabled
            if (updatedPermissions[index].can_read) {
                updatedPermissions[index] = {
                    ...updatedPermissions[index],
                    [type]: !updatedPermissions[index][type],
                    // full_access: (updatedPermissions[index].can_read && updatedPermissions[index].can_write && updatedPermissions[index].can_update && updatedPermissions[index].can_delete) ? true : false,
                };
            }
        }
        setPermissions(updatedPermissions);
    };

    const updateAllPermissions = (e: React.ChangeEvent<HTMLInputElement>, type: string) => {
        const isChecked = e.target.checked;
        if (type === "full_access") {
            const updatedPermissions = permissions.map((perm) => ({
                ...perm,
                full_access: true,
                can_read: true,
                can_write: true,
                can_update: true,
                can_delete: true,
            }));
            setPermissions(updatedPermissions);
        } else {
            if (type === "can_read") {
                const can_read = isChecked ? false : true;
                const updatedPermissions = permissions.map((perm) => ({ ...perm, can_read: !can_read, can_write: can_read ? false : perm.can_write, can_update: can_read ? false : perm.can_update, can_delete: can_read ? false : perm.can_delete, full_access: false }));
                setPermissions(updatedPermissions);
            } else {
                const updatedPermissions = permissions.map((perm) => ({
                    ...perm,
                    [type]: isChecked ? true : false,
                    can_read: true,
                    full_access: false,
                }));
                setPermissions(updatedPermissions);
            }
        }
    };

    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-ex-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Role" : "Add Role"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Row>
                            <Col lg={12} md={6} sm={12} className="mb-3">
                                {/* First Name */}
                                <Controller
                                    control={control}
                                    name="role"
                                    rules={{ required: "Please Enter Role" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Role</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Role"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.role}
                                            />
                                            {(errors["role"]?.message || Boolean(errors["role"]?.message) || (isTouched && !watchAllFields.role)) && (
                                                <div className="login-error">
                                                    <Label title={errors.role?.message || "Please Enter Role."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                            </Col>

                            <Col lg={12} md={12} sm={12} className="mb-3">
                                {/* Permissions */}
                                <p className="font-bold">Permissions</p>
                                <table className="mb-3 border p-1 rounded w-100">
                                    <thead className="border">
                                        <tr>
                                            <th className="border p-1">Module</th>
                                            <th className="border p-1"> <input className="form-check-input me-1" type="checkbox" onClick={(e: any) => updateAllPermissions(e, "full_access")} checked={permissions.filter((_) => _.full_access).length == permissions.length} />Full Access</th>
                                            <th className="border p-1"> <input className="form-check-input me-1" type="checkbox" onClick={(e: any) => updateAllPermissions(e, "can_read")} checked={permissions.filter((_) => _.can_read).length == permissions.length} />View</th>
                                            <th className="border p-1"> <input className="form-check-input me-1" type="checkbox" onClick={(e: any) => updateAllPermissions(e, "can_write")} checked={permissions.filter((_) => _.can_write).length == permissions.length} />Write</th>
                                            <th className="border p-1"> <input className="form-check-input me-1" type="checkbox" onClick={(e: any) => updateAllPermissions(e, "can_update")} checked={permissions.filter((_) => _.can_update).length == permissions.length} />Update</th>
                                            <th className="border p-1"> <input className="form-check-input me-1" type="checkbox" onClick={(e: any) => updateAllPermissions(e, "can_delete")} checked={permissions.filter((_) => _.can_delete).length == permissions.length} />Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {permissions.map((permission: any, index: number) => (
                                            <tr className="me-3 border-bottom mb-2" key={permission.id}>
                                                <td className="border p-1 font-medium m-0 mb-2">{HelperService.getFormatedModuleName(permission.name)}</td>
                                                <td className="border p-1 me-3">
                                                    <input className="form-check-input me-1" type="checkbox" checked={permission.full_access} onClick={() => onChangePermission(index, "full_access")} />
                                                    <label className="form-check-label">Full Access</label>
                                                </td>
                                                <td className="border p-1 me-3">
                                                    <input className="form-check-input me-1" type="checkbox" checked={permission.can_read} onClick={() => onChangePermission(index, "can_read")} />
                                                    <label className="form-check-label">View</label>
                                                </td>
                                                <td className="border p-1 me-3">
                                                    <input className="form-check-input me-1" type="checkbox" checked={permission.can_write} onClick={() => onChangePermission(index, "can_write")} />
                                                    <label className="form-check-label">Write</label>
                                                </td>
                                                <td className="border p-1 me-3">
                                                    <input className="form-check-input me-1" type="checkbox" checked={permission.can_update} onClick={() => onChangePermission(index, "can_update")} />
                                                    <label className="form-check-label">Update</label>
                                                </td>
                                                <td className="border p-1 me-3">
                                                    <input className="form-check-input me-1" type="checkbox" checked={permission.can_delete} onClick={() => onChangePermission(index, "can_delete")} />
                                                    <label className="form-check-label">Delete</label>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Col>

                        </Row>
                        <div className="text-center border-top">
                            <Button
                                variant="dark"
                                className="btn-brand-1 px-5 mt-3 mb-3 me-2"
                                type="submit"
                                id="changePassword-btn"
                            >
                                {isEdit ? "Update" : "Save"}
                            </Button>
                            <Button
                                variant="light"
                                className="btn-brand-1 px-5 mt-3 mb-3"
                                type="button"
                                onClick={() => closeModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddRole;
